<!-- Added by Vipul on 07-10-2026 -->
@if (!templateForPermitForm) {
  <div [ngClass]="{'form-group': showLabel}">
    <wm-de-label
      [entity]="entity"
      [for]="entity.templateCode"
      [displayOnly]="true"
      *ngIf="showLabel"
    ></wm-de-label>
    <wm-common-text
      [id]="entity.templateCode"
      [data]="{ text: modelValue | currency }"
    ></wm-common-text>
  </div>
} @else {
  <div class="free-form-text-style">
    <wm-common-text
      [data]="{ text: entity.label }"
      class="entity-text"
    ></wm-common-text>
    <wm-common-text
      [data]="{
        text: modelValue | currency
      }"
    >
    </wm-common-text>
  </div>
}
<!-- End by Vipul on 07-10-2026 -->
